import { __rest, __assign } from 'tslib';
import React__default, { createRef } from 'react';
import clsx from 'clsx';
import toggleInputByEnter from '../../util/toggleInputByEnter.js';
import { propTypes, defaultProps } from './Radio.types.js';
import styles from './Radio.module.scss.js';

var Radio = function (props) {
    var label = props.label, disabled = props.disabled, size = props.size, className = props.className, testId = props.testId, tabIndex = props.tabIndex, inputProps = __rest(props, ["label", "disabled", "size", "className", "testId", "tabIndex"]);
    var inputRef = createRef();
    var onKeyPress = toggleInputByEnter(inputRef);
    return (React__default.createElement("label", { className: clsx(styles.RadioInput, styles["RadioInput___".concat(size)], disabled && styles.RadioInput___disabled, className), tabIndex: disabled ? -1 : tabIndex, onKeyPress: onKeyPress },
        React__default.createElement("span", { className: clsx(styles.HoverBackground, styles["HoverBackground___".concat(size)]) }),
        label,
        React__default.createElement("input", __assign({ type: "radio", className: clsx(styles.RadioInput_check, styles.RadioInput_inputElement), disabled: disabled, "data-testid": props['data-testid'] || testId, ref: inputRef, tabIndex: -1 }, inputProps))));
};
Radio.displayName = 'Radio';
Radio.propTypes = propTypes;
Radio.defaultProps = defaultProps;

export { Radio as default };
